import { render, staticRenderFns } from "./Chek.vue?vue&type=template&id=bff93aec&scoped=true"
import script from "./Chek.vue?vue&type=script&lang=js"
export * from "./Chek.vue?vue&type=script&lang=js"
import style0 from "./Chek.vue?vue&type=style&index=0&id=bff93aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff93aec",
  null
  
)

export default component.exports